import { useStaticQuery, graphql } from "gatsby";

const HeaderQuery = () => {
  const headerData: Queries.Query = useStaticQuery(graphql`
    query HeaderDataQuery {
      allSanityHeader {
        nodes {
          headerContent {
            ... on SanityHeaderItems {
              ...sanityHeaderItems
            }
          }
          region {
            ...sanityRegion
          }
        }
      }
    }
  `);

  const {
    allSanityHeader: { nodes },
  } = headerData;

  const selectedHeader = nodes.find(
    node => node.region?.iban === process.env.GATSBY_IBAN
  );

  return selectedHeader;
};

export default HeaderQuery;
